import { Grid, Button, Badge } from "@mui/material";
import { grey } from "@mui/material/colors";
import CheckIcon from "@mui/icons-material/Check";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import PersonIcon from "@mui/icons-material/Person";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import ClearIcon from "@mui/icons-material/Clear";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ContentPasteOffIcon from "@mui/icons-material/ContentPasteOff";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import Helmet from "react-helmet";
import { HomeItem } from "../../components/common/home/HomeItem";
import { Role } from "../../common/roles/role";
import withRole from "../../common/roles/withRole";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import StorefrontIcon from "@mui/icons-material/Storefront";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import UndoIcon from '@mui/icons-material/Undo';
import { useSelector } from "react-redux";
import { useState } from "react";

import HomeNotifications from "../../components/common/home/HomeNotifications";
import { selectNotifications } from "../../common/features/notifications/notificationsSlice";
import distributorIds from "../../config/distributorIds.json";
import { canSeeDevoluciones } from "../../common/permissions/devolucionesAccess";

export default function Home() {
  const RestrictedMarinaHomeItem = withRole([Role.Marina])(HomeItem);
  const RestrictedKioskoHomeItem = withRole([Role.Kiosko])(HomeItem);
  const RestrictedPointsOfSaleButton = withRole([
    Role.Marina,
    Role.Editor,
    Role.Consulta,
    Role.Distribuidor,
  ])(HomeItem);
  const RestrictedConsumtionButton = withRole([
    Role.Marina,
    Role.Kiosko,
    Role.Distribuidor,
  ])(HomeItem);
  const RestrictedMarinaKioskoButton = withRole([Role.Marina, Role.Kiosko])(
    HomeItem
  );

  const { role } = useSelector((state) => state.auth.user || {});
  
  const  pointOfSale  = useSelector((state) => state.pointsOfSale.pointOfSale || {});

  const etaAllowedDistributorIds = Object.values(
    distributorIds[process.env.REACT_APP_ENVIRONMENT] ?? {}
  );

  const notifications = useSelector(selectNotifications);

  // Cambia viewAll a un contador
  const [viewAllCount, setViewAllCount] = useState(0);
  const [notifsVisible, setNotifsVisible] = useState([]);

  return (
    <>
      <Helmet>
        <title>Inicio - Marina BCN</title>
      </Helmet>
      {role === Role.Kiosko ? (
        <HomeNotifications
          activeNotifs={notifications}
          viewAllCount={viewAllCount}
          onVisibleChange={setNotifsVisible}
        />
      ) : null}
      <Grid
        container
        spacing={3}
        sx={{
          "& .MuiGrid-item": {
            display: "flex",
          },
          "& .MuiPaper-root": {
            bgcolor: grey[100],
            flexGrow: 1,
          },
          "& .MuiCardContent-root": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          },
          "& .MuiAvatar-root": {
            marginTop: 1,
            marginBottom: 0.5,
            bgcolor: "secondary.main",
            width: 40,
            height: 40,
          },
          "& .MuiSvgIcon-root": {
            fontSize: "1.5rem",
            color: grey[100],
          },
          "& .MuiTypography-root": {
            flexGrow: 1,
            textAlign: "center",
          },
        }}
      >
        {role === Role.Kiosko ? (
          <Grid item xs={12} md={12} lg={12}>
            <Button
              variant="text"
              endIcon={
                <Badge
                  badgeContent={notifications.length}
                  color="secondary"
                  overlap="circular"
                  sx={{ "& .MuiBadge-badge": { right: -12, top: 0 } }}
                  invisible={!notifications.length}
                ></Badge>
              }
              fullWidth
              size="medium"
              disabled={!notifications.length}
              onClick={() => setViewAllCount((prev) => prev + 1)}
              sx={{
                width: "100%",
                boxShadow: 1,
                bgcolor: grey[100],
                borderRadius: 1,
                "&:hover": {
                  bgcolor: grey[100],
                },
              }}
            >
              Notificaciones
            </Button>
          </Grid>
        ) : null}

        <HomeItem
          text="Consumo del día"
          icon={<AssignmentTurnedInIcon />}
          to="/day-consumptions"
        />
        <HomeItem
          text="Consumo Histórico"
          icon={<AssignmentIcon />}
          to="/historical-consumptions"
        />
        <RestrictedConsumtionButton
          text="Venta"
          icon={<CheckIcon />}
          to="/consumptions/new"
        />
        <RestrictedMarinaHomeItem
          text="Venta masiva"
          icon={<DoneAllIcon />}
          to="/consumptions/massive"
        />
        <RestrictedMarinaKioskoButton
          text="Venta atrasada"
          icon={<WatchLaterIcon />}
          to="/consumptions/new-delayed"
        />
        <RestrictedConsumtionButton
          text="Anular venta"
          icon={<ClearIcon />}
          to="/consumptions/cancel"
        />
        <RestrictedMarinaHomeItem
          text="Anular histórico"
          icon={<ContentPasteOffIcon />}
          to="/historical-consumptions/cancel"
        />
        <RestrictedKioskoHomeItem
          text="Mis clientes"
          icon={<AssignmentIndIcon />}
          to="/clients"
        />
        <RestrictedMarinaHomeItem
          text="Usuarios"
          icon={<PersonIcon />}
          to="/users"
        />
        <RestrictedPointsOfSaleButton
          text="Puntos de venta"
          icon={<StorefrontIcon />}
          to="/points-of-sale"
        />
        <RestrictedMarinaHomeItem
          text="Notificaciones"
          icon={<NotificationsIcon />}
          to="/notifications"
        />
        {etaAllowedDistributorIds.includes(pointOfSale.id_distributor) && (
          <RestrictedKioskoHomeItem
            text="Llegada estimada"
            icon={<LocalShippingIcon />}
            to="/estimated-time-arrival"
          />
        )}
        {canSeeDevoluciones(pointOfSale) && (
          <RestrictedKioskoHomeItem
            text="Informar devoluciones"
            icon={<UndoIcon />}
            to="/albaranes"
          />
        )}
      </Grid>
    </>
  );
}
